<template>
  <vs-popup class="add-new-incoterms"
            id="popup"
            title="Session Expired"
            @close="open = true"
            :active.sync="open"
            :buttons-hidden="true">
      <div class="px-3">
        <p>You have left this browser idle for 5 minutes.</p>
        <p>{{ time / 1000}} second left</p>
      </div>
  </vs-popup>
</template>

<script>

  import { mapActions } from "vuex";

  function initialState() {
    return {
      open: true,
      time: 10000,
    }
  }

  export default {
    name: 'AddNewCcpItemPopUp',
    data() {
      return initialState()
    },
    created() {
      let timerId = setInterval(() => {
        this.time -= 1000;
        if (!this.$store.state.idleVue.isIdle) clearInterval(timerId);

        if (this.time < 1) {
          clearInterval(timerId);
          localStorage.removeItem('userInfo')
          this.logout()
        }
      }, 1000);
    },
    methods: {
      ...mapActions(['logout']),
    },
    components: {
    },
    mixins: [],
  }
</script>

<style scoped>
  .add-new-incoterms >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
